import { FormattedMessage } from 'react-intl'

import { SearchResult } from '@/components/Form/AudienceTargeting/Audience/interfaces'
import { Organization, Person } from '@/components/Icons'

import messages from './messages'

import './index.scss'

const AttributeFieldResult = ({ term, type, subtitle, displayValue, name }: SearchResult) => (
  <div className="attribute-field__result">
    <div className="result__left">{type === 'individual' ? <Person /> : <Organization />}</div>
    <div className="result__right">
      <p>{displayValue || term?.toString() || name}</p>

      {subtitle && (
        <p>
          {type === 'group' && <FormattedMessage {...messages.members} values={{ count: subtitle }} />}
          {type === 'individual' && subtitle}
        </p>
      )}
    </div>
  </div>
)

export default AttributeFieldResult
